module.exports = __webpack_public_path__ + "fonts/Roboto-Bold.cf6c1c7.woff";